import { makeStyles, tokens } from '@fluentui/react-components';

export const useByodSectionStyles = makeStyles({
    byodContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM
    },
    itemTitle: {
        fontSize: tokens.fontSizeBase400
    },
    viewReceiptLink: {
        color: tokens.colorBrandForegroundLink,
        textDecorationLine: 'underline',
        cursor: 'pointer'
    }
});
